export enum OptionType {
  AdventureActivities = 'ADVENTUREACTIVITY',
  BusinessBenefit = 'BUSINESS',
  Cruise = 'CRUISE',
  Endorsement = 'ENDR',
  LuggagePercentage = 'LUGGAGEPERCENT',
  PolicyExcessBuyoutFixed = 'POLEXCESS',
  PolicyExcessBuyoutPercentage = 'POLEXCESSPERCENT',
  PreEx = 'PREEX',
  RentalVehicleExcess = 'CAREXCESS',
  SnowSports = 'SNOWSPORTS',
  SpecifiedItems = 'SPECITEMS',
  TravelClear = 'TRAVELCLEAR',
  TripCancellationFixed = 'TRIPCANX',
  TripCancellationPercentage = 'TRIPCANXPERCENT',
  PrivateMedicalInsurance = 'PMI',
}
